module.exports = __webpack_public_path__ + "static/img/juridicos.e54ec95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/markers/hq/juridicos.png
// module id = fRV5
// module chunks = 1